export default {
    uz: {
        message: {
            this_seat_is_selected_by_other_user: 'Bu joy boshqa foydalanuvchi tomonidan tanlangan. Iltimos boshqa joyni tanlang',
            buy_ticket: 'Avtovokzal narxida biletlarni sotish',
            tashkent: 'Toshkent',
            where: 'Qayerga',
            when: 'Qachon',
            next: 'Keyingi',
            Next: 'Keyingi',
            no_stations: 'Bu viloyatda xozircha stansiyalar mavjud emas',
            back: 'Orqaga',
            trips: 'Reyslar yo`q | 1 ta reys | {n} ta reys | {n} ta reys',
            trips_for: '{date} SANADAGI REYSLAR',
            distance: '{distance} km',
            sum: 'so`m',
            etd: 'Ketish vaqti',
            eta: 'Yetib borish vaqti',
            trip_name: 'Reys nomi',
            empty_seats: 'Bo`sh o`rinlar soni',
            tariff: 'Tarif (so`m)',
            bus: 'Avtobus',
            loading: 'Yuklanmoqda',
            no_trips: 'Belgilangan sanada reyslar yo`q',
            first_floor: 'Birinchi qavat',
            second_floor: 'Ikkinchi qavat',
            empty: 'Bo`sh o`rindiqlar',
            bron: 'Band o`rindiqlar',
            reserved: 'Rezervga olingan',
            selected: 'Tanlangan',
            station_tax: 'Avtovokzal yig`imi',
            total: 'Jami',
            set_order: 'Buyurtmani rasmiylashtirish',
            passenger: 'Yo`lovchilar',
            fio: 'F.I.O',
            phone: 'Telefon',
            email: 'E-mail',
            required_fields: 'to`ldirish majburiy',
            to_payment: 'To`lovga o`tish',
            booked: 'Zaxira o`rindiqlar bo`shashi uchun {seconds} qoldi',
            h: 's',
            m: 'm',
            s: 's',
        }
    },
    ru: {
        message: {
            this_seat_is_selected_by_other_user: 'Это место выбрано другим пользователем. Пожалуйста, выберите другое место.',
            buy_ticket: 'Продажа билетов по цене автовокзала',
            tashkent: 'Ташкент',
            where: 'Куда',
            when: 'Когда',
            next: 'Далее',
            no_stations: 'В этот локаци пока вокзал нету',
            back: 'Назад',
            trips: 'нет рейсов | 1 рейс | {n} рейса | {n} рейсов',
            trips_for: 'РЕЙСЫ НА {date}',
            distance: '{distance} км',
            sum: 'сум',
            etd: 'Отправление',
            eta: 'Прибытие',
            trip_name: 'Название рейса',
            empty_seats: 'Кол. пустых мест',
            tariff: 'Тариф (сум)',
            bus: 'Автобус',
            loading: 'Загружается',
            no_trips: 'В указанную дату автобус не ходит.',
            first_floor: 'Первый этаж',
            second_floor: 'Второй этаж',
            empty: 'Свободно',
            bron: 'Занято',
            reserved: 'Резерв',
            selected: 'Выбрано',
            station_tax: 'Сбор автовокзала',
            total: 'Итого',
            set_order: 'Оформление заказа',
            passenger: 'Пассажиры',
            fio: 'Ф.И.О.',
            phone: 'Телефон',
            email: 'E-mail',
            required_fields: 'обязательные для заполнения поля',
            to_payment: 'К оплате',
            booked: 'Зарезервированные места освободятся через: {seconds}',
            h: 'ч',
            m: 'м',
            s: 'с',
        }
    },
    en: {
        message: {
            this_seat_is_selected_by_other_user: 'This location has been selected by another user. Please select another location.',
            buy_ticket: 'Ticket sales for the price of a bus station',
            tashkent: 'Tashkent',
            where: 'Where',
            when: 'When',
            next: 'Further',
            no_stations: "In this location, while the station is not present",
            back: 'Back',
            trips: 'no flights | 1 flight | {n} flights',
            trips_for: 'FLIGHTS TO {date}',
            distance: '{distance} km',
            sum: 'sum',
            etd: 'Departure',
            eta: 'Arrival',
            trip_name: 'Flight Name',
            empty_seats: 'Count of empty seats',
            tariff: 'Tariff (sum)',
            bus: 'Bus',
            loading: 'Loading',
            no_trips: "The bus does not run on this date.",
            first_floor: 'Ground floor',
            second_floor: 'Second floor',
            empty: 'Free',
            bron: 'Busy',
            reserved: 'Reserved',
            selected: 'Selected',
            station_tax: 'Bus station collection',
            total: 'Total',
            set_order: 'Checkout',
            passenger: 'Passengers',
            fio: 'FULL NAME.',
            phone: 'Phone',
            email: 'E-mail',
            required_fields: 'required fields',
            to_payment: 'To pay',
            booked: 'Reserved seats will be freed through: {seconds}',
            h: 'h',
            m: 'm',
            s: 's',
        }
    }
}
